export const SIDEBAR_OPTION_STYLES: string =
  'flex items-center gap-x-2 w-full group font-medium text-primary-900 dark:text-primary-100 rounded-md px-2 py-2 text-ms leading-6 hover:bg-primary-200/70 dark:hover:bg-primary-800'

export const PROSE_CLASSNAMES: string =
  'prose prose-light america:prose-headings:text-blue-900 america:prose-strong:text-blue-900 dark:prose-invert text-primary-900 dark:text-primary-100'

export const PROSE_CLASSNAMES_NODARK: string =
  'prose prose-light america:prose-headings:text-blue-900 america:prose-strong:text-blue-900 text-primary-900'
